import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';

import '../../styles/components/integrationStatus.less';

// One tile for every integration status on the booking overview (MS-6748): the sync's name on top,
// its state below in the state's colour, always the same width as its neighbour (the parent lays
// the tiles out in a two-column grid) and at least 44 px tall. CRM sync (OutPerform) and BOT sync
// (the ERP RPA Bot) both render through this so they cannot drift apart again.
//
// `tone` is the colour rule shared by both:
//   waiting   — slate: queued, pending, retrying, sending
//   done      — green: sent / success
//   attention — orange: failed, needs a person
//   closed    — grey: resolved by hand, not sent, nothing to show
export const TONES = ['waiting', 'done', 'attention', 'closed'];

export default function IntegrationStatusTile({
  name, state, tone, icon, onClick, ariaLabel, testId, loading, disabled, expanded,
}) {
  const t = TONES.indexOf(tone) >= 0 ? tone : 'closed';
  return (
    <button
      type="button"
      className={`integration-tile integration-tile--${t}`}
      onClick={onClick}
      aria-label={ariaLabel || `${name}: ${state}`}
      aria-haspopup={onClick ? 'dialog' : undefined}
      aria-expanded={onClick ? Boolean(expanded) : undefined}
      disabled={disabled || !onClick}
      data-testid={testId}
      data-tone={t}
    >
      <Icon name={icon} loading={loading} className="integration-tile__icon" aria-hidden="true" />
      <span className="integration-tile__text">
        <span className="integration-tile__name">{name}</span>
        <span className="integration-tile__state">{state}</span>
      </span>
    </button>
  );
}

IntegrationStatusTile.propTypes = {
  name: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  tone: PropTypes.oneOf(TONES),
  icon: PropTypes.string,
  onClick: PropTypes.func,
  ariaLabel: PropTypes.string,
  testId: PropTypes.string,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  expanded: PropTypes.bool,
};

IntegrationStatusTile.defaultProps = {
  tone: 'closed',
  icon: 'exchange',
  onClick: null,
  ariaLabel: '',
  testId: undefined,
  loading: false,
  disabled: false,
  expanded: false,
};



// WEBPACK FOOTER //
// ./src/components/Crm/IntegrationStatusTile.jsx